export enum QueryKeys {
    releases = 'releases',
    filters = 'filters',
    notifications = 'notifications',
    searchReleases = 'searchReleases',
    affiliateMe = 'affiliateMe',
    affiliateStats = 'affiliateStats',
    affiliateReferrals = 'affiliateReferrals',
    affiliateCommissions = 'affiliateCommissions',
    affiliatePayouts = 'affiliatePayouts',
    affiliateCodes = 'affiliateCodes',
    affiliateProgramPublic = 'affiliateProgramPublic',
    affiliateInvite = 'affiliateInvite',
    adminAffiliates = 'adminAffiliates',
    droplists = 'droplists',
}
